import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import AccordionActions from '@material-ui/core/AccordionActions';
import IconCheckbox from '../IconCheckbox';
import Filters from '../Filters/Filters';
import Alert from '@material-ui/lab/Alert';
import { Paper } from '@material-ui/core';

export default function AccountsTable({
	type,
	accounts,
	vats,
	productTypes,
	paymentTypes,
	discounts,
	cashbackPaymentTypes,
	links,
	products,
	floors,
	onLinkChange,
	onDelete,
	onEdit,
	contacts,
	tags,
	productMode,
}) {
	const [currentAccountId, setCurrentAccountId] = useState(null);

	let [data, setData] = useState([]);
	let [_accounts, setAccount] = useState([]);

	useEffect(() => {
		setAccount(accounts[type] || []);
		switch (type) {
			case 'payment':
				setData(paymentTypes);
				break;
			case 'cashback':
				if (cashbackPaymentTypes && cashbackPaymentTypes.length) {
					setData(cashbackPaymentTypes);
				}
				break;
			case 'vat':
				setData(vats);
				break;
			case 'offered':
			case 'discount':
			case '_discount':
			case '_offered':
				setData(discounts);
				break;
			case 'product':
				setData(productMode == 'tag' ? tags : productTypes);
				break;
		}
	}, [type, productMode]);

	const onSelectAll = accountId => {
		const keyIdTable = ['vat'].includes(type) ? 'tax_rate' : 'id';
		let toInsert = [];
		for (let d of data) {
			if (
				!links[accountId] ||
				(links[accountId] && !links[accountId][d[keyIdTable]])
			) {
				toInsert.push(d[keyIdTable]);
			}
			onLinkChange(accountId, toInsert, type, true, []);
		}
	};

	return (
		<>
			{_accounts &&
				_accounts.map((a, i) => {
					let labelFloors = '';
					if (type == 'product')
						if (a.all_floors) labelFloors = 'Toutes les salles';
						else
							labelFloors = a.floors
								.reduce((acc, id_floor) => {
									const f = floors.find(f => f.id == id_floor);
									if (f) acc.push(f.name);
									return acc;
								}, [])
								.join(', ');

					if (['achats', 'ventes', 'customer'].includes(type)) {
						const link = a.linking[0];
						if (link) {
							const ca = contacts.find(c => c.id == link.id_table); // check if customer account
							return (
								<Paper style={{ padding: 15 }}>
									<Typography>
										{`${a.label} (${a.account_number}) - identifiant : ${
											ca ? ca.name : link.id_table
										}`}{' '}
									</Typography>
									<Button
										size="small"
										color="primary"
										onClick={() => onEdit(a._id)}>
										Modifier compte
									</Button>
									<Button
										size="small"
										color="secondary"
										onClick={() => onDelete(a._id)}>
										Supprimer compte
									</Button>
								</Paper>
							);
						} else {
							return '';
						}
					} else {
						const allChecked =
							links[a._id] && Object.keys(links[a._id]).length == data.length;

						return (
							<div key={`accoordion-${type}-${i}`}>
								<Accordion
									expanded={currentAccountId == a.id}
									onChange={() =>
										setCurrentAccountId(currentAccountId == a.id ? null : a.id)
									}>
									<AccordionSummary
										expandIcon={<ExpandMoreIcon />}
										id={`acummary-${a.id}`}>
										<Typography>{`${a.label} (${a.account_number}) - ${labelFloors}`}</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<div
											className="account-table-container"
											key={`cont-${a.id}`}>
											{![
												'payment',
												'offered',
												'discount',
												'_offered',
												'_discount',
											].includes(type) ? (
												<>
													<div
														className="account-table-row"
														style={{ display: 'flex' }}>
														<div className="account-table-row-name">
															<ListItemIcon
																onClick={_ => {
																	onSelectAll(a._id);
																}}>
																<IconCheckbox checked={allChecked} />
															</ListItemIcon>
															<p> Tout sélectionner </p>
														</div>
													</div>
													<hr />
												</>
											) : null}

											{data.map(row => {
												const keyIdTable = ['vat'].includes(type)
													? 'tax_rate'
													: 'id';

												const link =
													links[a._id] && links[a._id][row[keyIdTable]]
														? links[a._id][row[keyIdTable]]
														: null;

												let classesRow = 'account-table-row';
												let disabled = false;
												if (
													[
														'payment',
														'offered',
														'discount',
														'_offered',
														'_discount',
													].includes(type) &&
													!link
												) {
													const otherSameTypeSelectedInOtherAccount = [];
													for (let accountId in links) {
														if (a._id != accountId) {
															for (let linkId in links[accountId]) {
																let link = links[accountId][linkId];
																if (link.type == type) {
																	otherSameTypeSelectedInOtherAccount.push(
																		link.id_table
																	);
																}
															}
														}
													}
													disabled =
														otherSameTypeSelectedInOtherAccount.includes(
															row[keyIdTable]
														);
												}

												if (disabled)
													classesRow += ' account-table-row-disabled';

												let selectedTaxRates = [];
												if (link && link.all_tax_rates) {
													selectedTaxRates = [...vats];
												} else if (link && link.tax_rates) {
													selectedTaxRates = vats.filter(
														v =>
															link.tax_rates.find(tr => tr == v.tax_rate) !=
															null
													);
												}

												return (
													<div
														className={classesRow}
														key={`${row.type}-${row.id}-${a.id}`}
														id={`${row.type}-${row.id}-${a.id}`}
														style={{ display: 'flex' }}>
														<div className="account-table-row-name">
															<ListItemIcon
																onClick={_ =>
																	disabled
																		? null
																		: onLinkChange(
																				a._id,
																				row[keyIdTable],
																				type,
																				!!link ? false : true,
																				[]
																		  )
																}>
																<IconCheckbox checked={!!link} />
															</ListItemIcon>
															<p>{row.name} </p>
														</div>

														{type == 'product' && link ? (
															<div className="account-table-row-vat">
																<Filters
																	multiple={true}
																	monoSelect={false}
																	disabledClickAway={true}
																	label="Toutes les TVA"
																	datas={vats}
																	paramsLabel="name"
																	paramsValue="tax_rate"
																	selected={selectedTaxRates}
																	inputClassName="dataExport_filter_input"
																	inputLabelClassName="dataExport_input_label"
																	onClose={(data, pValue) => {
																		if (!!data) {
																			onLinkChange(
																				a._id,
																				row.id.toString(),
																				type,
																				false,
																				data.map(t => t.tax_rate)
																			);
																		}

																		return;
																	}}
																/>
															</div>
														) : null}
													</div>
												);
											})}
										</div>
									</AccordionDetails>
									<Divider />
									<AccordionActions>
										<Button
											size="small"
											color="primary"
											onClick={() => onEdit(a._id)}>
											Modifier compte
										</Button>
										<Button
											size="small"
											color="secondary"
											onClick={() => onDelete(a._id)}>
											Supprimer compte
										</Button>
									</AccordionActions>
								</Accordion>
							</div>
						);
					}
				})}

			{!_accounts || (_accounts && !_accounts.length) ? (
				<div style={{ marginTop: 20 }}>
					<Alert severity="info">
						Aucun compte comptable de ce type n'est configuré
					</Alert>
				</div>
			) : null}
		</>
	);
}
